export default __webpack_public_path__ + "static/media/frame-login-tablet.fa07888e.png";